
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/guaranteed-contracts",
      function () {
        return require("private-next-pages/admin/guaranteed-contracts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/guaranteed-contracts"])
      });
    }
  